<div class="catalog-content">
  <app-create-job
    [jobData]="activeJobData"
    (refreshChange)="onRefresh()"
  ></app-create-job>
  <app-list-job (editChange)="onJobEdit($event)"></app-list-job>
</div>
